import { createAction, createSlice } from "@reduxjs/toolkit";
import paymentService from "../service/payment.service";
import { checkGroupPayments } from "../utils/checkPayments";
import { getGroupId } from "../service/http.localStorage";
import { asList, readContent, replaceById } from "../utils/readContent";

const paymentsSlice = createSlice({
  name: "payment",
  initialState: {
    entities: null,
    isLoading: false,
    error: null,
  },
  reducers: {
    paymentsRequested: (state) => {
      state.isLoading = true;
    },
    paymentsReceived: (state, action) => {
      state.entities = action.payload;
      state.isLoading = false;
    },
    paymentCreateReceived: (state, action) => {
      state.entities = replaceById(state.entities, action.payload);
      state.isLoading = false;
    },
    paymentsRequestFailed: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    paymentRemoved: (state, action) => {
      state.entities = state.entities.filter((c) => c._id !== action.payload);
    },
    paymentLogOut: (state) => {
      state.entities = null;
    },
  },
});

const { reducer: paymentsReducer, actions } = paymentsSlice;

const {
  paymentsRequested,
  paymentsReceived,
  paymentsRequestFailed,
  paymentCreateReceived,
  paymentLogOut,
} = actions;

const addPaymentRequested = createAction("payment/addPaymentRequested");

export const loadPaymentList = () => async (dispatch) => {
  dispatch(paymentsRequested());
  try {
    dispatch(paymentsReceived(asList(await paymentService.getPayments())));
  } catch (error) {
    dispatch(paymentsRequestFailed(error.message));
  }
};

export const createPayment = (payload) => async (dispatch) => {
  dispatch(addPaymentRequested(payload));
  try {
    const content = readContent(await paymentService.create(payload));
    if (!content || content._id == null) {
      dispatch(paymentsRequestFailed("empty"));
      return null;
    }
    dispatch(paymentCreateReceived(content));
    return content;
  } catch (error) {
    dispatch(paymentsRequestFailed(error.message));
    return null;
  }
};

export const getPayments = () => (state) => state.payment.entities;

export const getPaymentSumByMissionId = (missionId) => (state) => {
  const user = state.users.entities
    ? state.users.entities.find((item) => item._id === state.users.auth?.userId)
    : null;
  const group = Array.isArray(state.groups.entities)
    ? state.groups.entities.find(
        (item) => String(item._id) === String(user?.teamId)
      )
    : null;
  const teamId = group?._id || user?.teamId || getGroupId();
  if (!Array.isArray(state.payment.entities) || !teamId || missionId == null) {
    return 0;
  }
  const payments = state.payment.entities.filter(
    (elem) =>
      elem &&
      String(elem.teamId) === String(teamId) &&
      String(elem.missionId) === String(missionId)
  );
  return checkGroupPayments(payments, missionId) || 0;
};

export const logOutPayment = () => (dispatch) => {
  dispatch(paymentLogOut());
};

export default paymentsReducer;
